module.exports = [
  {
    slug: "/infrastructure",
    bgImage: require('../assets/Home/DAIF_Menu.jpg'),
    videoTransitionIn: require('../assets/04_Infrastructure/DAIF_Infra_In.mp4'),
    videoBgLoop: require('../assets/04_Infrastructure/DAIF_Infra_Loop.mp4'),
    bgImage2: require('../assets/04_Infrastructure/DAIF_Infra_Clean.jpg'),
    ctas: [
      {
        url: "/",
        width: "4%",
        height: "8%",
        top: "86.5%",
        left: "3.4%",
      },
      {
        url: "/infrastructure/1in",
        width: "30%",
        height: "4.5%",
        top: "74.6%",
        left: "66.4%",
      },
      {
        url: "/infrastructure/2in",
        width: "30%",
        height: "4.5%",
        top: "79.2%",
        left: "66.4%",
      },
      {
        url: "/infrastructure/3in",
        width: "30%",
        height: "4.5%",
        top: "83.9%",
        left: "66.4%",
      },
      {
        url: "/infrastructure/4in",
        width: "30%",
        height: "4.5%",
        top: "88.5%",
        left: "66.4%",
      },
    ],
  },
  {
    slug: "/infrastructureb",
    bgImage: require('../assets/04_Infrastructure/DAIF_Infra_Clean.jpg'),
    videoTransitionIn: require('../assets/04_Infrastructure/DAIF_Infra_Loop.mp4'),
    videoBgLoop: require('../assets/04_Infrastructure/DAIF_Infra_Loop.mp4'),
    bgImage2: require('../assets/04_Infrastructure/DAIF_Infra_Clean.jpg'),
    ctas: [
      {
        url: "/",
        width: "4%",
        height: "8%",
        top: "86.5%",
        left: "3.4%",
      },
      {
        url: "/infrastructure/1in",
        width: "30%",
        height: "4.5%",
        top: "74.6%",
        left: "66.4%",
      },
      {
        url: "/infrastructure/2in",
        width: "30%",
        height: "4.5%",
        top: "79.2%",
        left: "66.4%",
      },
      {
        url: "/infrastructure/3in",
        width: "30%",
        height: "4.5%",
        top: "83.9%",
        left: "66.4%",
      },
      {
        url: "/infrastructure/4in",
        width: "30%",
        height: "4.5%",
        top: "88.5%",
        left: "66.4%",
      },
    ],
  },

  {
    slug: "/infrastructure/1in",
    bgImage: require('../assets/04_Infrastructure/DAIF_Infra_Clean.jpg'),
    videoTransitionIn: require('../assets/04_Infrastructure/DAIF_Infra_Screen1.mp4'),
    videoTransitionInEnd: require('../assets/04_Infrastructure/DAIF_Infra_Screen1-end.jpg'),
    videoBgLoop: "",
    bgImage2: require('../assets/04_Infrastructure/DAIF_Infra_Screen1-end.jpg'),
    ctas: [],
    autoNavigateURL: "/infrastructure/1",
  },
  {
    slug: "/infrastructure/2in",
    bgImage: require('../assets/04_Infrastructure/DAIF_Infra_Clean.jpg'),
    videoTransitionIn: require('../assets/04_Infrastructure/DAIF_Infra_Screen1.mp4'),
    videoTransitionInEnd: require('../assets/04_Infrastructure/DAIF_Infra_Screen1-end.jpg'),
    videoBgLoop: "",
    bgImage2: require('../assets/04_Infrastructure/DAIF_Infra_Screen1-end.jpg'),
    ctas: [],
    autoNavigateURL: "/infrastructure/2",
  },
  {
    slug: "/infrastructure/3in",
    bgImage: require('../assets/04_Infrastructure/DAIF_Infra_Clean.jpg'),
    videoTransitionIn: require('../assets/04_Infrastructure/DAIF_Infra_Screen1.mp4'),
    videoTransitionInEnd: require('../assets/04_Infrastructure/DAIF_Infra_Screen1-end.jpg'),
    videoBgLoop: "",
    bgImage2: require('../assets/04_Infrastructure/DAIF_Infra_Screen1-end.jpg'),
    ctas: [],
    autoNavigateURL: "/infrastructure/3",
  },
  {
    slug: "/infrastructure/4in",
    bgImage: require('../assets/04_Infrastructure/DAIF_Infra_Clean.jpg'),
    videoTransitionIn: require('../assets/04_Infrastructure/DAIF_Infra_Screen1.mp4'),
    videoTransitionInEnd: require('../assets/04_Infrastructure/DAIF_Infra_Screen1-end.jpg'),
    videoBgLoop: "",
    bgImage2: require('../assets/04_Infrastructure/DAIF_Infra_Screen1-end.jpg'),
    ctas: [],
    autoNavigateURL: "/infrastructure/4/1", // /infrastructure/4
  },

  {
    slug: "/infrastructure/1",
    bgImage: require('../assets/04_Infrastructure/DAIF_Infra_Screen1-end.jpg'),
    videoTransitionIn: require('../assets/04_Infrastructure/04_DAIF_Infra_01_01.mp4'),
    videoTransitionInEnd: require('../assets/04_Infrastructure/04_DAIF_Infra_01_01_end.jpg'),
    videoBgLoop: "",
    bgImage2: require('../assets/04_Infrastructure/04_DAIF_Infra_01_01_end.jpg'),
    ctas: [
      {
        url: "/",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "3.6%",
      },
      {
        url: "/infrastructureb",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "7.4%",
      },
      {
        url: "/infrastructure/1/1",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "93.3%",
      },
    ],
  },
  {
    slug: "/infrastructure/1/1",
    bgImage: require('../assets/04_Infrastructure/04_DAIF_Infra_01_01_end.jpg'),
    videoTransitionIn: require('../assets/04_Infrastructure/04_DAIF_Infra_01_02.mp4'),
    videoBgLoop: require('../assets/04_Infrastructure/04_DAIF_Infra_01_02_loop.mp4'),
    bgImage2: require('../assets/04_Infrastructure/04_DAIF_Infra_01_02-end.jpg'),
    ctas: [
      {
        url: "/",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "3.6%",
      },
      {
        url: "/infrastructureb",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "7.4%",
      },
      {
        url: "/infrastructure/1",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "93.3%",
      },
    ],
  },

  {
    slug: "/infrastructure/2",
    bgImage: require('../assets/04_Infrastructure/DAIF_Infra_Screen1-end.jpg'),
    videoTransitionIn: require('../assets/04_Infrastructure/04_DAIF_Infra_02.mp4'),
    videoTransitionInEnd: require('../assets/04_Infrastructure/04_DAIF_Infra_02_end.jpg'),
    videoBgLoop: "",
    bgImage2: require('../assets/04_Infrastructure/04_DAIF_Infra_02_end.jpg'),
    ctas: [
      {
        url: "/",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "3.6%",
      },
      {
        url: "/infrastructureb",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "7.4%",
      },
    ],
  },

  {
    slug: "/infrastructure/3",
    bgImage: require('../assets/04_Infrastructure/DAIF_Infra_Screen1-end.jpg'),
    videoTransitionIn: require('../assets/04_Infrastructure/04_DAIF_Infra_03_01.mp4'),
    videoBgLoop: require('../assets/04_Infrastructure/04_DAIF_Infra_03_01_loop.mp4'),
    bgImage2: require('../assets/04_Infrastructure/04_DAIF_Infra_03_01-end.jpg'),
    ctas: [
      {
        url: "/",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "3.6%",
      },
      {
        url: "/infrastructureb",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "7.4%",
      },
      {
        url: "/infrastructure/3/1",
        width: "11.4%",
        height: "19%",
        top: "33.8%",
        left: "14.5%",
      },
      {
        url: "/infrastructure/3/2",
        width: "11.4%",
        height: "19%",
        top: "33.8%",
        left: "29.5%",
      },
      {
        url: "/infrastructure/3/3",
        width: "11.4%",
        height: "19%",
        top: "33.8%",
        left: "44.3%",
      },
      {
        url: "/infrastructure/3/4",
        width: "11.4%",
        height: "19%",
        top: "33.8%",
        left: "59.3%",
      },
      {
        url: "/infrastructure/3/5",
        width: "11.4%",
        height: "19%",
        top: "33.8%",
        left: "74.1%",
      },
      {
        url: "/infrastructure/3/6",
        width: "15.3%",
        height: "4.5%",
        top: "54%",
        left: "42.5%",
      },
      {
        url: "/infrastructure/3/7",
        width: "11.4%",
        height: "19%",
        top: "58.8%",
        left: "21.8%",
      },
      {
        url: "/infrastructure/3/8",
        width: "11.4%",
        height: "19%",
        top: "58.8%",
        left: "36.7%",
      },
      {
        url: "/infrastructure/3/9",
        width: "11.4%",
        height: "19%",
        top: "58.8%",
        left: "51.8%",
      },
      {
        url: "/infrastructure/3/10",
        width: "11.4%",
        height: "19%",
        top: "58.8%",
        left: "67.2%",
      },
    ],
  },

  {
    slug: "/infrastructure/3/1",
    bgImage: require('../assets/04_Infrastructure/04_DAIF_Infra_03_01-end.jpg'),
    videoTransitionIn: require('../assets/04_Infrastructure/Screen_Infrastructure_04_03.mp4'),
    videoTransitionInEnd: require('../assets/04_Infrastructure/Screen_Infrastructure_04_03-end.jpg'),
    videoBgLoop: "",
    bgImage2: require('../assets/04_Infrastructure/Screen_Infrastructure_04_03-end.jpg'),
    ctas: [
      {
        url: "/",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "3.6%",
      },
      {
        url: "/infrastructureb",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "7.4%",
      },
      {
        url: "/infrastructure/3",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "93.3%",
      },
    ],
  },

  {
    slug: "/infrastructure/3/2",
    bgImage: require('../assets/04_Infrastructure/04_DAIF_Infra_03_01-end.jpg'),
    videoTransitionIn: require('../assets/04_Infrastructure/04_DAIF_Infra_04_04.mp4'),
    videoBgLoop: require('../assets/04_Infrastructure/04_DAIF_Infra_04_04_loop.mp4'),
    bgImage2: require('../assets/04_Infrastructure/04_DAIF_Infra_04_04-end.jpg'),
    ctas: [
      {
        url: "/",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "3.6%",
      },
      {
        url: "/infrastructureb",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "7.4%",
      },
      {
        url: "/infrastructure/3",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "93.3%",
      },
    ],
  },

  {
    slug: "/infrastructure/3/3",
    bgImage: require('../assets/04_Infrastructure/04_DAIF_Infra_03_01-end.jpg'),
    videoTransitionIn: require('../assets/04_Infrastructure/04_DAIF_Infra_03_13_PowerSwitch.mp4'),
    videoTransitionInEnd: require('../assets/04_Infrastructure/04_DAIF_Infra_03_13_PowerSwitch_end.jpg'),
    videoBgLoop: "",
    bgImage2: require('../assets/04_Infrastructure/04_DAIF_Infra_03_13_PowerSwitch_end.jpg'),
    ctas: [
      {
        url: "/",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "3.6%",
      },
      {
        url: "/infrastructureb",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "7.4%",
      },
      {
        url: "/infrastructure/3",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "93.3%",
      },
    ],
  },

  {
    slug: "/infrastructure/3/4",
    bgImage: require('../assets/04_Infrastructure/04_DAIF_Infra_03_01-end.jpg'),
    videoTransitionIn: require('../assets/04_Infrastructure/04_DAIF_Infra_03_15_PowerProtect.mp4'),
    videoTransitionInEnd: require('../assets/04_Infrastructure/04_DAIF_Infra_03_15_PowerProtect_end.jpg'),
    videoBgLoop: "",
    bgImage2: require('../assets/04_Infrastructure/04_DAIF_Infra_03_15_PowerProtect_end.jpg'),
    ctas: [
      {
        url: "/",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "3.6%",
      },
      {
        url: "/infrastructureb",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "7.4%",
      },
      {
        url: "/infrastructure/3",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "93.3%",
      },
    ],
  },

  {
    slug: "/infrastructure/3/5",
    bgImage: require('../assets/04_Infrastructure/04_DAIF_Infra_03_01-end.jpg'),
    videoTransitionIn: require('../assets/04_Infrastructure/04_DAIF_Infra_03_09_PowerScaleOneFS.mp4'),
    videoBgLoop: require('../assets/04_Infrastructure/04_DAIF_Infra_03_09_PowerScaleOneFS_loop.mp4'),
    bgImage2: require('../assets/04_Infrastructure/04_DAIF_Infra_03_09_PowerScaleOneFS-end.jpg'),
    ctas: [
      {
        url: "/",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "3.6%",
      },
      {
        url: "/infrastructureb",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "7.4%",
      },
      {
        url: "/infrastructure/3",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "93.3%",
      },
      {
        url: "/infrastructure/3/5/1",
        width: "3%",
        height: "5.9%",
        top: "76.6%",
        left: "83.2%",
      },
    ],
  },
  {
    slug: "/infrastructure/3/5/1",
    bgImage: require('../assets/04_Infrastructure/04_DAIF_Infra_03_09_PowerScaleOneFS-end.jpg'),
    videoTransitionIn: require('../assets/04_Infrastructure/04_DAIF_Infra_03_10.mp4'),
    videoTransitionInEnd: require('../assets/04_Infrastructure/04_DAIF_Infra_03_10_end.jpg'),
    videoBgLoop: "",
    bgImage2: require('../assets/04_Infrastructure/04_DAIF_Infra_03_10_end.jpg'),
    ctas: [
      {
        url: "/",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "3.6%",
      },
      {
        url: "/infrastructureb",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "7.4%",
      },
      {
        url: "/infrastructure/3",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "93.3%",
      },
      {
        url: "/infrastructure/3/5",
        width: "3%",
        height: "5.9%",
        top: "76.6%",
        left: "80.1%",
      },
      {
        url: "/infrastructure/3/5/2",
        width: "3%",
        height: "5.9%",
        top: "76.6%",
        left: "83.2%",
      },
    ],
  },
  {
    slug: "/infrastructure/3/5/2",
    bgImage: require('../assets/04_Infrastructure/04_DAIF_Infra_03_10_end.jpg'),
    videoTransitionIn: require('../assets/04_Infrastructure/04_DAIF_Infra_03_11.mp4'),
    videoBgLoop: require('../assets/04_Infrastructure/04_DAIF_Infra_03_11_loop.mp4'),
    bgImage2: require('../assets/04_Infrastructure/04_DAIF_Infra_03_10_end.jpg'),
    ctas: [
      {
        url: "/",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "3.6%",
      },
      {
        url: "/infrastructureb",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "7.4%",
      },
      {
        url: "/infrastructure/3",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "93.3%",
      },
      {
        url: "/infrastructure/3/5/1",
        width: "3%",
        height: "5.9%",
        top: "76.6%",
        left: "83.2%",
      },
    ],
  },

  {
    slug: "/infrastructure/3/6",
    bgImage: require('../assets/04_Infrastructure/04_DAIF_Infra_03_01-end.jpg'),
    videoTransitionIn: require('../assets/04_Infrastructure/04_DAIF_Infra_03_02_poweredge.mp4'),
    videoBgLoop: require('../assets/04_Infrastructure/04_DAIF_Infra_03_02_poweredge_loop.mp4'),
    bgImage2: require('../assets/04_Infrastructure/04_DAIF_Infra_03_02_poweredge-end.jpg'),
    ctas: [
      {
        url: "/",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "3.6%",
      },
      {
        url: "/infrastructureb",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "7.4%",
      },
      {
        url: "/infrastructure/3",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "93.3%",
      },
      {
        url: "/infrastructure/3/6/1",
        width: "3%",
        height: "5.9%",
        top: "80.6%",
        left: "83.2%",
      },
    ],
  },
  {
    slug: "/infrastructure/3/6/1",
    bgImage: require('../assets/04_Infrastructure/04_DAIF_Infra_03_02_poweredge-end.jpg'),
    videoTransitionIn: require('../assets/04_Infrastructure/04_DAIF_Infra_03_03_powereddge_facts.mp4'),
    videoBgLoop: require('../assets/04_Infrastructure/04_DAIF_Infra_03_03_powereddge_facts_loop.mp4'),
    bgImage2: require('../assets/04_Infrastructure/04_DAIF_Infra_03_03_powereddge_facts-end.jpg'),
    ctas: [
      {
        url: "/",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "3.6%",
      },
      {
        url: "/infrastructureb",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "7.4%",
      },
      {
        url: "/infrastructure/3",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "93.3%",
      },
      {
        url: "/infrastructure/3/6",
        width: "3%",
        height: "5.9%",
        top: "80.6%",
        left: "80.1%",
      },
      {
        url: "/infrastructure/3/6/2",
        width: "3%",
        height: "5.9%",
        top: "80.6%",
        left: "83.2%",
      },
    ],
  },
  {
    slug: "/infrastructure/3/6/2",
    bgImage: require('../assets/04_Infrastructure/04_DAIF_Infra_03_03_powereddge_facts-end.jpg'),
    videoTransitionIn: require('../assets/04_Infrastructure/04_DAIF_Infra_03_04_powereddge_facts.mp4'),
    videoBgLoop: require('../assets/04_Infrastructure/04_DAIF_Infra_03_04_powereddge_facts_loop.mp4'),
    bgImage2: require('../assets/04_Infrastructure/04_DAIF_Infra_03_04_powereddge_facts-end.jpg'),
    ctas: [
      {
        url: "/",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "3.6%",
      },
      {
        url: "/infrastructureb",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "7.4%",
      },
      {
        url: "/infrastructure/3",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "93.3%",
      },
      {
        url: "/infrastructure/3/6/1",
        width: "3%",
        height: "5.9%",
        top: "80.6%",
        left: "83.2%",
      },
    ],
  },

  {
    slug: "/infrastructure/3/7",
    bgImage: require('../assets/04_Infrastructure/04_DAIF_Infra_03_01-end.jpg'),
    videoTransitionIn: require('../assets/04_Infrastructure/04_DAIF_Infra_03_07_XESeries.mp4'),
    videoTransitionInEnd: require('../assets/04_Infrastructure/04_DAIF_Infra_03_07_XESeries_end.jpg'),
    videoBgLoop: "",
    bgImage2: require('../assets/04_Infrastructure/04_DAIF_Infra_03_07_XESeries_end.jpg'),
    ctas: [
      {
        url: "/",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "3.6%",
      },
      {
        url: "/infrastructureb",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "7.4%",
      },
      {
        url: "/infrastructure/3",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "93.3%",
      },
    ],
  },

  {
    slug: "/infrastructure/3/8",
    bgImage: require('../assets/04_Infrastructure/04_DAIF_Infra_03_01-end.jpg'),
    videoTransitionIn: require('../assets/04_Infrastructure/04_DAIF_Infra_03_06_XRSeries.mp4'),
    videoTransitionInEnd: require('../assets/04_Infrastructure/04_DAIF_Infra_03_06_XRSeries_end.jpg'),
    videoBgLoop: "",
    bgImage2: require('../assets/04_Infrastructure/04_DAIF_Infra_03_06_XRSeries_end.jpg'),
    ctas: [
      {
        url: "/",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "3.6%",
      },
      {
        url: "/infrastructureb",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "7.4%",
      },
      {
        url: "/infrastructure/3",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "93.3%",
      },
    ],
  },

  {
    slug: "/infrastructure/3/9",
    bgImage: require('../assets/04_Infrastructure/04_DAIF_Infra_03_01-end.jpg'),
    videoTransitionIn: require('../assets/04_Infrastructure/04_DAIF_Infra_03_05_RSeries.mp4'),
    videoTransitionInEnd: require('../assets/04_Infrastructure/04_DAIF_Infra_03_05_RSeries_end.jpg'),
    videoBgLoop: "",
    bgImage2: require('../assets/04_Infrastructure/04_DAIF_Infra_03_05_RSeries_end.jpg'),
    ctas: [
      {
        url: "/",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "3.6%",
      },
      {
        url: "/infrastructureb",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "7.4%",
      },
      {
        url: "/infrastructure/3",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "93.3%",
      },
    ],
  },

  {
    slug: "/infrastructure/3/10",
    bgImage: require('../assets/04_Infrastructure/04_DAIF_Infra_03_01-end.jpg'),
    videoTransitionIn: require('../assets/04_Infrastructure/04_DAIF_Infra_03_08_TSeries.mp4'),
    videoTransitionInEnd: require('../assets/04_Infrastructure/04_DAIF_Infra_03_08_TSeries_end.jpg'),
    videoBgLoop: "",
    bgImage2: require('../assets/04_Infrastructure/04_DAIF_Infra_03_08_TSeries_end.jpg'),
    ctas: [
      {
        url: "/",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "3.6%",
      },
      {
        url: "/infrastructureb",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "7.4%",
      },
      {
        url: "/infrastructure/3",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "93.3%",
      },
    ],
  },

  // {
  //   slug: "/infrastructure/4",
  //   bgImage: require('../assets/04_Infrastructure/DAIF_Infra_Screen1-end.jpg'),
  //   videoTransitionIn: require('../assets/04_Infrastructure/04_DAIF_Infra_04_01.mp4'),
  //   videoBgLoop: require('../assets/04_Infrastructure/04_DAIF_Infra_04_01_loop.mp4'),
  //   bgImage2: require('../assets/04_Infrastructure/04_DAIF_Infra_04_01-end.jpg'),
  //   ctas: [
  //     {
  //       url: "/",
  //       width: "3.5%",
  //       height: "8%",
  //       top: "86.5%",
  //       left: "3.6%",
  //     },
  //     {
  //       url: "/infrastructureb",
  //       width: "3.5%",
  //       height: "8%",
  //       top: "86.5%",
  //       left: "7.4%",
  //     },
  //     {
  //       url: "/infrastructure/4/1",
  //       width: "3.5%",
  //       height: "8%",
  //       top: "86.5%",
  //       left: "93.3%",
  //     },
  //   ],
  // },
  {
    slug: "/infrastructure/4/1",
    bgImage: require('../assets/04_Infrastructure/DAIF_Infra_Screen1-end.jpg'), // 04_DAIF_Infra_04_01-end.jpg
    videoTransitionIn: require('../assets/04_Infrastructure/04_DAIF_Infra_04_02.mp4'),
    videoBgLoop: require('../assets/04_Infrastructure/04_DAIF_Infra_04_02_loop.mp4'),
    bgImage2: require('../assets/04_Infrastructure/04_DAIF_Infra_04_02-end.jpg'),
    ctas: [
      {
        url: "/",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "3.6%",
      },
      {
        url: "/infrastructureb",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "7.4%",
      },
      // {
      //   url: "/infrastructure/4",
      //   width: "3.5%",
      //   height: "8%",
      //   top: "86.5%",
      //   left: "89.7%",
      // },
      {
        url: "/infrastructure/4/2",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "93.3%",
      },
    ],
  },
  {
    slug: "/infrastructure/4/2",
    bgImage: require('../assets/04_Infrastructure/04_DAIF_Infra_04_02-end.jpg'),
    videoTransitionIn: require('../assets/04_Infrastructure/04_DAIF_Infra_04_03.mp4'),
    videoTransitionInEnd: require('../assets/04_Infrastructure/04_DAIF_Infra_04_03_end.jpg'),
    videoBgLoop: "",
    bgImage2: require('../assets/04_Infrastructure/04_DAIF_Infra_04_03_end.jpg'),
    ctas: [
      {
        url: "/",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "3.6%",
      },
      {
        url: "/infrastructureb",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "7.4%",
      },
      {
        url: "/infrastructure/4/1",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "89.7%",
      },
      {
        url: "/infrastructure/4/3",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "93.3%",
      },
    ],
  },
  {
    slug: "/infrastructure/4/3",
    bgImage: require('../assets/04_Infrastructure/04_DAIF_Infra_04_03_end.jpg'),
    videoTransitionIn: require('../assets/04_Infrastructure/04_DAIF_Infra_04_04_alt.mp4'),
    videoBgLoop: require('../assets/04_Infrastructure/04_DAIF_Infra_04_04_alt_loop.mp4'),
    bgImage2: require('../assets/04_Infrastructure/04_DAIF_Infra_04_04-end.jpg'),
    ctas: [
      {
        url: "/",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "3.6%",
      },
      {
        url: "/infrastructureb",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "7.4%",
      },
      {
        url: "/infrastructure/4/2",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "89.7%",
      },
      {
        url: "/infrastructure/4/4",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "93.3%",
      },
    ],
  },
  {
    slug: "/infrastructure/4/4",
    bgImage: require('../assets/04_Infrastructure/04_DAIF_Infra_04_04-end.jpg'),
    videoTransitionIn: require('../assets/04_Infrastructure/04_DAIF_Infra_04_05.mp4'),
    videoTransitionInEnd: require('../assets/04_Infrastructure/04_DAIF_Infra_04_05_end.jpg'),
    videoBgLoop: "",
    bgImage2: require('../assets/04_Infrastructure/04_DAIF_Infra_04_05_end.jpg'),
    ctas: [
      {
        url: "/",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "3.6%",
      },
      {
        url: "/infrastructureb",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "7.4%",
      },
      {
        url: "/infrastructure/4/3",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "89.7%",
      },
      {
        url: "/infrastructure/4/6", // /4/5
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "93.3%",
      },
    ],
  },
  // {
  //   slug: "/infrastructure/4/5",
  //   bgImage: require('../assets/04_Infrastructure/04_DAIF_Infra_04_05_end.jpg'),
  //   videoTransitionIn: require('../assets/04_Infrastructure/04_DAIF_Infra_04_06.mp4'),
  //   videoTransitionInEnd: require('../assets/04_Infrastructure/04_DAIF_Infra_04_06_end.jpg'),
  //   videoBgLoop: "",
  //   bgImage2: require('../assets/04_Infrastructure/04_DAIF_Infra_04_06_end.jpg'),
  //   ctas: [
  //     {
  //       url: "/",
  //       width: "3.5%",
  //       height: "8%",
  //       top: "86.5%",
  //       left: "3.6%",
  //     },
  //     {
  //       url: "/infrastructureb",
  //       width: "3.5%",
  //       height: "8%",
  //       top: "86.5%",
  //       left: "7.4%",
  //     },
  //     {
  //       url: "/infrastructure/4/4",
  //       width: "3.5%",
  //       height: "8%",
  //       top: "86.5%",
  //       left: "89.7%",
  //     },
  //     {
  //       url: "/infrastructure/4/6",
  //       width: "3.5%",
  //       height: "8%",
  //       top: "86.5%",
  //       left: "93.3%",
  //     },
  //   ],
  // },
  {
    slug: "/infrastructure/4/6",
    bgImage: require('../assets/04_Infrastructure/04_DAIF_Infra_04_05_end.jpg'), // 04_DAIF_Infra_04_06_end.jpg
    videoTransitionIn: require('../assets/04_Infrastructure/04_DAIF_Infra_04_07.mp4'),
    videoTransitionInEnd: require('../assets/04_Infrastructure/04_DAIF_Infra_04_07_end.jpg'),
    videoBgLoop: "",
    bgImage2: require('../assets/04_Infrastructure/04_DAIF_Infra_04_07_end.jpg'),
    ctas: [
      {
        url: "/",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "3.6%",
      },
      {
        url: "/infrastructureb",
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "7.4%",
      },
      {
        url: "/infrastructure/4/4", // /4/5
        width: "3.5%",
        height: "8%",
        top: "86.5%",
        left: "93.3%",
      },
    ],
  },
]